import React from 'react';
import { observer } from 'mobx-react';
import './index.scss';
import { toJS } from 'mobx';

function getStateDesc(state) {
  switch (parseInt(state, 10)) {
    case 0:
      return '无车';
    case 1:
      return '有车';
    default:
      return '';
  }
}

function BroadcastDetail(props) {
  const store = props.store;

  return (
    <div className="broadcast-detail">
      <div className="broadcast-detail-header">
        <div>车位号 {store.parkingno}</div>
        <div>mac：{store.mac}</div>
      </div>
      <div className="broadcast-detail-list">
        {
          Object.assign([], toJS(store.list)).reverse().map(item => (
            <div className="broadcast-detail-list-item" key={item.detectTime}>
              <div className="left">
                <div>检测时间：{item.detectTime}</div>
                <div>
                  <div>雷达状态：<span className="emphasis">{getStateDesc(item.state)}</span></div>
                  <div>上传耗时：<span className="emphasis">{item.millis}s</span></div>
                </div>
              </div>
              <div className={['right', item.state === 1 ? 'has-car' : 'no-car'].join(' ')}>
                <div>{getStateDesc(item.state)}</div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default observer(BroadcastDetail);
